<template lang="pug">
div(:class="rowClasses" @click="performClick")
  .column
    p.title.is-4 {{ title }}
    .subtitle.is-6.level.is-mobile
      .level-left
        .level-item(v-if="icon")
          font-awesome-icon(:icon="icon" size="1x" :class="iconClass")
        .level-item
          span {{ subtitle }}
</template>

<script>
export default {
  data () {
    return {}
  },

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    iconClass: {
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: false
    },
    onClick: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    rowClasses () {
      return 'columns is-6 row is-mobile' + (this.disabled ? ' disabled' : '')
    }
  },
  methods: {
    performClick () {
      if (this.disabled) return
      this.$emit('action', this.item)
    }
  }
}
</script>

<style scoped lang="scss">
.row:hover {
  background: hsl(0, 0%, 96%);
  cursor: pointer;
}
.row.disabled {
  background-color: hsl(0, 0%, 98%);
  &:hover {
    background: none;
    cursor: not-allowed;
  }
  .title {
    color: hsl(0, 0%, 80%);
  }
}
</style>
